import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMixer } from '../context/MixerContext';
import { experiences, projects, achievements } from '../data/resumeData';
import { filterByRelevance } from '../utils/contentTransform';
import ProfileHeader from './ProfileHeader';
import ExperienceCard from './ExperienceCard';
import ProjectCard from './ProjectCard';
import ArchiveView from './ArchiveView';
import ProjectDeepDive from './ProjectDeepDive';
import './ContentArea.css';

export default function ContentArea() {
  const { viewMode, mixerState } = useMixer();
  const [activeDeepDive, setActiveDeepDive] = useState(null);
  
  const sortedExperiences = filterByRelevance(experiences, mixerState);
  const sortedProjects = filterByRelevance(projects, mixerState);
  
  const handleDeepDive = (projectId) => {
    setActiveDeepDive(projectId);
  };
  
  const closeDeepDive = () => {
    setActiveDeepDive(null);
  };
  
  return (
    <main className="content-area">
      <AnimatePresence mode="wait">
        {viewMode === 'live' ? (
          <motion.div
            key="live"
            className="content-area__live"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <ProfileHeader />
            
            <section className="content-area__section">
              <div className="content-area__section-header">
                <h2 className="content-area__section-title">Experience</h2>
                <span className="content-area__section-count">{experiences.length} roles</span>
              </div>
              <div className="content-area__experiences">
                {sortedExperiences.map((exp, index) => (
                  <ExperienceCard 
                    key={exp.id} 
                    experience={exp} 
                    index={index}
                    onDeepDive={handleDeepDive}
                  />
                ))}
              </div>
            </section>
            
            <section className="content-area__section">
              <div className="content-area__section-header">
                <h2 className="content-area__section-title">Projects</h2>
                <span className="content-area__section-count">{projects.length} projects</span>
              </div>
              <div className="content-area__projects">
                {sortedProjects.map((project, index) => (
                  <ProjectCard 
                    key={project.id} 
                    project={project} 
                    index={index}
                    onDeepDive={handleDeepDive}
                  />
                ))}
              </div>
            </section>
            
            <section className="content-area__section content-area__section--achievements">
              <div className="content-area__section-header">
                <h2 className="content-area__section-title">Recognition</h2>
              </div>
              <div className="content-area__achievements">
                {achievements.map((achievement, index) => (
                  <motion.div 
                    key={index}
                    className="content-area__achievement"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <span className="content-area__achievement-title">{achievement.title}</span>
                    <span className="content-area__achievement-year">{achievement.year}</span>
                  </motion.div>
                ))}
              </div>
            </section>
          </motion.div>
        ) : (
          <motion.div
            key="archive"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            <ArchiveView />
          </motion.div>
        )}
      </AnimatePresence>
      
      <AnimatePresence>
        {activeDeepDive && (
          <ProjectDeepDive 
            projectId={activeDeepDive} 
            onClose={closeDeepDive}
          />
        )}
      </AnimatePresence>
    </main>
  );
}
